<template>
  <div class="customer-management">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>客户管理</span>
          <div>
            <el-button v-if="showPublicSeaButton" type="primary" plain @click="handlePublicSea">
              客户公海
            </el-button>
            <el-button type="warning" @click="handleImport">
              <el-icon><Upload /></el-icon>
              导入客户
            </el-button>
            <el-button type="success" @click="handleImportRecords">
              <el-icon><Document /></el-icon>
              导入记录
            </el-button>
            <el-button type="info" @click="handleExport" :loading="exportLoading">
              <el-icon><Download /></el-icon>
              导出客户
            </el-button>
            <el-button type="primary" @click="handleCreate">新增客户</el-button>
          </div>
        </div>
      </template>

      <!-- 搜索表单 -->
      <el-form :model="queryParams" class="search-form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="客户姓名">
              <el-input
                v-model="queryParams.customerName"
                placeholder="请输入客户姓名"
                clearable
                @keyup.enter="handleSearch"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户手机">
              <el-input
                v-model="queryParams.contactPhone"
                placeholder="请输入客户手机"
                clearable
                @keyup.enter="handleSearch"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="意向等级">
              <el-select v-model="queryParams.intentionLevel" placeholder="全部" clearable style="width: 100%">
                <el-option
                  v-for="item in intentionLevelOptions"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dataCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属分组">
              <el-select v-model="queryParams.groupId" placeholder="全部分组" clearable style="width: 100%">
                <el-option
                  v-for="item in groupOptions"
                  :key="item.id"
                  :label="item.groupName"
                  :value="String(item.id)"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="enterpriseCrmEnabled" :gutter="20">
          <el-col :span="6">
            <el-form-item label="商机阶段">
              <el-select v-model="queryParams.opportunityStage" placeholder="全部" clearable style="width: 100%">
                <el-option
                  v-for="item in crmStageOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生命周期">
              <el-select v-model="queryParams.lifecycleStatus" placeholder="全部" clearable style="width: 100%">
                <el-option
                  v-for="item in crmLifecycleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="重点跟进" class="follow-up-item">
              <el-switch
                v-model="queryParams.followUpReminder"
                :active-value="1"
                :inactive-value="null"
                active-text="是"
                inactive-text="全部"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="所在地区" class="region-item">
              <div class="region-select-group">
                <el-select
                  v-model="queryParams.provinceId"
                  placeholder="省"
                  clearable
                  style="width: 110px"
                  @change="handleProvinceChange"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <span class="region-separator">/</span>
                <el-select
                  v-model="queryParams.cityId"
                  placeholder="市"
                  clearable
                  style="width: 110px"
                  :disabled="!queryParams.provinceId"
                  @change="handleCityChange"
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <span class="region-separator">/</span>
                <el-select
                  v-model="queryParams.regionId"
                  placeholder="区"
                  clearable
                  style="width: 110px"
                  :disabled="!queryParams.cityId"
                >
                  <el-option
                    v-for="item in districtOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label=" ">
              <div class="action-buttons-inline">
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button @click="handleReset">重置</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 客户列表 -->
      <div class="table-wrapper">
        <el-table
          v-loading="loading"
          :data="customerList"
          border
          stripe
          style="width: 100%"
          table-layout="auto"
        >
          <el-table-column prop="id" label="ID" min-width="60" width="80" />
          <el-table-column prop="customerName" label="客户姓名" min-width="90" show-overflow-tooltip />
          <el-table-column prop="contactPhone" label="客户手机" min-width="110" show-overflow-tooltip />
          <el-table-column prop="followUpReminder" label="重点跟进" min-width="90" width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="row.followUpReminder === 1 ? 'success' : 'info'" size="small">
                {{ row.followUpReminder === 1 ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="regionName" label="所在地区" min-width="150" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.regionName || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="address" label="客户地址" min-width="150" show-overflow-tooltip />
          <el-table-column prop="customerType" label="客户类型" min-width="90" width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="row.customerType === 'intention' ? 'warning' : 'info'" size="small">
                {{ row.customerType === 'intention' ? '意向' : '普通' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="intentionLevel" label="意向等级" min-width="90" width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="getIntentionLevelType(row.intentionLevel)" size="small">
                {{ getIntentionLevelName(row.intentionLevel) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="enterpriseCrmEnabled" label="商机阶段" min-width="100" show-overflow-tooltip>
            <template #default="{ row }">
              {{ (crmMeta.opportunityStages && row.opportunityStage && crmMeta.opportunityStages[row.opportunityStage]) || row.opportunityStage || '-' }}
            </template>
          </el-table-column>
          <el-table-column v-if="enterpriseCrmEnabled" label="生命周期" min-width="100" show-overflow-tooltip>
            <template #default="{ row }">
              {{ (crmMeta.lifecycleStatuses && row.lifecycleStatus && crmMeta.lifecycleStatuses[row.lifecycleStatus]) || row.lifecycleStatus || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="groupName" label="所属分组" min-width="100" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="150" width="180">
            <template #default="{ row }">
              {{ formatDateTime(row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="200" width="248" fixed="right" align="left">
            <template #default="{ row }">
              <div class="customer-table-ops">
                <el-button type="primary" size="small" @click="handleView(row)">详情</el-button>
                <el-button type="warning" size="small" @click="handleEdit(row)">编辑</el-button>
                <el-button type="info" size="small" plain @click="handleOpenCustomerLog(row)">客户日志</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          v-model:current-page="queryParams.page"
          v-model:page-size="queryParams.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <!-- 客户详情/编辑对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="dialogTitle"
      width="920px"
      class="customer-form-dialog"
      @close="handleDialogClose"
    >
      <!-- 查看模式 -->
      <div v-if="isView && customerForm.customerId" v-loading="detailLoading" class="customer-detail">
        <!-- 基础信息卡片 -->
        <el-card class="detail-card" shadow="never">
          <template #header>
            <div class="card-title">
              <span class="title-text">基础信息</span>
              <span class="title-tip">客户基础资料</span>
            </div>
          </template>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="客户姓名">
              {{ customerForm.customerName || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="客户职位">
              {{ customerForm.customerPosition || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="客户手机">
              {{ customerForm.contactPhone || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="重点跟进">
              <el-tag :type="customerForm.followUpReminder === 1 ? 'success' : 'info'" size="small">
                {{ customerForm.followUpReminder === 1 ? '是' : '否' }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 归属与联系卡片 -->
        <el-card class="detail-card" shadow="never">
          <template #header>
            <div class="card-title">
              <span class="title-text">归属与联系</span>
              <span class="title-tip">帮助团队快速定位客户</span>
            </div>
          </template>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="所在地区">
              {{ customerForm.regionName || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="客户地址">
              {{ customerForm.address || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="所属公司">
              {{ customerForm.companyName || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="所属分组">
              {{ customerForm.groupName || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="关联客户">
              {{ customerForm.customerSource || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="关联客户手机">
              {{ customerForm.customerSourcePhone || '-' }}
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 标签与备注卡片 -->
        <el-card class="detail-card" shadow="never">
          <template #header>
            <div class="card-title">
              <span class="title-text">标签与备注</span>
            </div>
          </template>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="客户类型">
              <el-tag :type="customerForm.customerType === 'intention' ? 'warning' : 'info'" size="small">
                {{ customerForm.customerType === 'intention' ? '意向客户' : (customerForm.customerType === 'normal' ? '普通客户' : (customerForm.customerType || '-')) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="意向等级">
              <el-tag :type="getIntentionLevelType(customerForm.intentionLevel)" size="small">
                {{ getIntentionLevelName(customerForm.intentionLevel) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="客户信息" :span="2">
              {{ customerForm.detailInfo || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="备注" :span="2">
              {{ customerForm.remark || '-' }}
            </el-descriptions-item>
            <el-descriptions-item v-if="enterpriseCrmEnabled" label="商机阶段">
              {{ (crmMeta.opportunityStages && customerForm.opportunityStage && crmMeta.opportunityStages[customerForm.opportunityStage]) || customerForm.opportunityStage || '-' }}
            </el-descriptions-item>
            <el-descriptions-item v-if="enterpriseCrmEnabled && customerForm.opportunityStage === crmMeta.opportunityStageLoseCode" label="输单原因">
              {{ (crmMeta.loseReasons && customerForm.loseReason && crmMeta.loseReasons[customerForm.loseReason]) || customerForm.loseReason || '-' }}
            </el-descriptions-item>
            <el-descriptions-item v-if="enterpriseCrmEnabled" label="生命周期">
              {{ (crmMeta.lifecycleStatuses && customerForm.lifecycleStatus && crmMeta.lifecycleStatuses[customerForm.lifecycleStatus]) || customerForm.lifecycleStatus || '-' }}
            </el-descriptions-item>
            <el-descriptions-item v-if="enterpriseCrmEnabled" label="合同到期日">
              {{ customerForm.contractExpireDate || '-' }}
            </el-descriptions-item>
            <el-descriptions-item v-if="enterpriseCrmEnabled" label="阶段变更记录跟进">
              <el-tag :type="customerForm.addFollowOnOpportunityStageChange ? 'success' : 'info'" size="small">
                {{ customerForm.addFollowOnOpportunityStageChange ? '是' : '否' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">
              {{ formatDateTime(customerForm.createTime) }}
            </el-descriptions-item>
            <el-descriptions-item label="更新时间">
              {{ formatDateTime(customerForm.updateTime) }}
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </div>

      <!-- 新增/编辑模式 -->
      <el-form
        v-else
        ref="customerFormRef"
        :model="customerForm"
        :rules="customerFormRules"
        label-width="128px"
        class="customer-edit-form"
      >
        <!-- 基础信息卡片 -->
        <el-card class="form-card" shadow="never">
          <template #header>
            <div class="card-title">
              <span class="title-text">基础信息</span>
              <span class="title-tip">客户基础资料</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="客户姓名" prop="customerName">
                <el-input v-model="customerForm.customerName" placeholder="请输入客户姓名" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户职位">
                <el-input v-model="customerForm.customerPosition" placeholder="请输入客户职位" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="客户手机" prop="contactPhone">
                <el-input v-model="customerForm.contactPhone" placeholder="请输入客户手机" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="重点跟进">
                <el-switch
                  v-model="customerForm.followUpReminder"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 归属与联系卡片 -->
        <el-card class="form-card" shadow="never">
          <template #header>
            <div class="card-title">
              <span class="title-text">归属与联系</span>
              <span class="title-tip">帮助团队快速定位客户</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="所在地区">
                <div class="region-select-wrapper">
                  <el-input
                    :model-value="selectedRegionText"
                    placeholder="请选择所在地区（省/市/区）"
                    readonly
                    @click="handleOpenRegionDialog"
                  >
                    <template #suffix>
                      <el-icon class="cursor-pointer" @click="handleOpenRegionDialog">
                        <Location />
                      </el-icon>
                    </template>
                  </el-input>
                  <el-button
                    type="primary"
                    plain
                    @click="handleOpenRegionDialog"
                    style="margin-left: 10px"
                  >
                    选择地区
                  </el-button>
                  <el-button
                    v-if="customerForm.regionId"
                    type="danger"
                    plain
                    @click="handleClearRegion"
                    style="margin-left: 10px"
                  >
                    清除
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="客户地址">
                <el-input
                  v-model="customerForm.address"
                  placeholder="请输入客户地址"
                  clearable
                  style="width: 100%"
                >
                  <template #append>
                    <el-button :icon="Location" @click="openLocationPicker" :loading="locationLoading">
                      定位
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属公司">
                <el-input v-model="customerForm.companyName" placeholder="请输入所属公司" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属分组">
                <el-select v-model="customerForm.groupId" placeholder="请选择所属分组" clearable style="width: 100%">
                  <el-option
                    v-for="item in groupOptions"
                    :key="item.id"
                    :label="item.groupName"
                    :value="String(item.id)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="关联客户">
                <el-input v-model="customerForm.customerSource" placeholder="请输入关联客户" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关联客户手机" prop="customerSourcePhone">
                <el-input v-model="customerForm.customerSourcePhone" placeholder="请输入关联客户手机" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <el-card v-if="enterpriseCrmEnabled" class="form-card form-card-crm" shadow="never">
          <template #header>
            <div class="card-title">
              <span class="title-text">企业 CRM</span>
            </div>
          </template>
          <el-row :gutter="20" class="crm-form-row">
            <el-col :span="12">
              <el-form-item label="商机阶段">
                <el-select v-model="customerForm.opportunityStage" placeholder="请选择" clearable style="width: 100%" @change="onOpportunityStageChange">
                  <el-option
                    v-for="item in crmStageOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="!isView" :span="12">
              <el-form-item class="crm-stage-follow-item" label-width="168px">
                <template #label>
                  <span class="crm-stage-follow-label">阶段变更记录跟进</span>
                </template>
                <div class="crm-stage-follow-wrap">
                  <el-radio-group v-model="customerForm.addFollowOnOpportunityStageChange" class="crm-follow-radio-group">
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                  <p class="crm-stage-follow-hint">选「是」并保存后，将写入一条拜访跟进（下次跟进日为当天）；若本次修改了商机阶段，跟进说明中会体现变更前后阶段。</p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="customerForm.opportunityStage === crmMeta.opportunityStageLoseCode" :gutter="20" class="crm-form-row">
            <el-col :span="12">
              <el-form-item label="输单原因">
                <el-select v-model="customerForm.loseReason" placeholder="请选择" clearable style="width: 100%">
                  <el-option
                    v-for="item in crmLoseReasonOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="crm-form-row">
            <el-col :span="12">
              <el-form-item label="客户生命周期">
                <el-select v-model="customerForm.lifecycleStatus" placeholder="请选择" clearable style="width: 100%">
                  <el-option
                    v-for="item in crmLifecycleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同到期日">
                <el-date-picker
                  v-model="customerForm.contractExpireDate"
                  type="date"
                  value-format="YYYY-MM-DD"
                  placeholder="选填"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 标签与备注卡片 -->
        <el-card class="form-card" shadow="never">
          <template #header>
            <div class="card-title">
              <span class="title-text">标签与备注</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="客户类型">
                <el-select v-model="customerForm.customerType" placeholder="请选择客户类型" style="width: 100%" @change="handleCustomerTypeChange">
                  <el-option label="普通客户" value="normal" />
                  <el-option label="意向客户" value="intention" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="customerForm.customerType === 'intention'">
              <el-form-item label="意向等级" prop="intentionLevel">
                <el-select v-model="customerForm.intentionLevel" placeholder="请选择意向等级" clearable style="width: 100%">
                  <el-option
                    v-for="item in intentionLevelOptions"
                    :key="item.dataCode"
                    :label="item.dataName"
                    :value="item.dataCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="客户信息" prop="detailInfo">
                <el-input
                  v-model="customerForm.detailInfo"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入客户信息"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  v-model="customerForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入备注"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">{{ isView ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!isView" type="primary" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>

    <!-- 客户公海 -->
    <el-dialog
      v-model="publicSeaDialogVisible"
      title="客户公海"
      width="1200px"
      destroy-on-close
    >
      <el-form :inline="true" :model="publicSeaQuery" class="search-form">
        <el-form-item label="客户姓名">
          <el-input
            v-model="publicSeaQuery.customerName"
            placeholder="请输入客户姓名"
            clearable
            style="width: 200px"
            @keyup.enter="handlePublicSeaSearch"
          />
        </el-form-item>
        <el-form-item label="客户手机">
          <el-input
            v-model="publicSeaQuery.contactPhone"
            placeholder="请输入客户手机"
            clearable
            style="width: 200px"
            @keyup.enter="handlePublicSeaSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePublicSeaSearch">查询</el-button>
          <el-button @click="handlePublicSeaReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        v-loading="publicSeaLoading"
        :data="publicSeaList"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="customerName" label="客户姓名" min-width="120" show-overflow-tooltip />
        <el-table-column prop="contactPhone" label="客户手机" min-width="130" show-overflow-tooltip />
        <el-table-column prop="companyName" label="所属公司" min-width="160" show-overflow-tooltip />
        <el-table-column prop="regionName" label="所在地区" min-width="160" show-overflow-tooltip />
        <el-table-column prop="address" label="客户地址" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" min-width="170">
          <template #default="{ row }">
            {{ formatDateTime(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170" fixed="right">
          <template #default="{ row }">
            <div class="customer-table-ops">
              <el-button type="primary" size="small" @click="handleView(row)">详情</el-button>
              <el-button type="info" size="small" plain @click="handleOpenCustomerLog(row)">客户日志</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination" style="margin-top: 20px">
        <el-pagination
          v-model:current-page="publicSeaQuery.page"
          v-model:page-size="publicSeaQuery.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="publicSeaTotal"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handlePublicSeaSizeChange"
          @current-change="handlePublicSeaPageChange"
        />
      </div>

      <template #footer>
        <el-button type="primary" @click="publicSeaDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 导入客户对话框 -->
    <el-dialog
      v-model="importDialogVisible"
      title="导入客户"
      width="600px"
      @close="handleImportDialogClose"
    >
      <div class="import-content">
        <el-alert
          title="导入说明"
          type="info"
          :closable="false"
          style="margin-bottom: 20px"
        >
          <template #default>
            <div style="line-height: 1.8">
              <p style="display: flex; align-items: center; gap: 8px;">
                <span>1. 请先下载导入模板，按照模板格式填写数据</span>
                <el-button 
                  type="primary" 
                  size="small" 
                  @click="handleDownloadTemplate" 
                  :loading="templateLoading"
                  style="margin-left: 8px;"
                >
                  <el-icon><Download /></el-icon>
                  下载导入模板
                </el-button>
              </p>
              <p>2. 必填字段（带*号）：客户姓名*、客户手机*、客户信息*</p>
              <p>3. 客户手机必须是11位手机号</p>
              <p>4. 支持导入 .xlsx 和 .xls 格式的Excel文件</p>
              <p v-if="enterpriseCrmEnabled">
                5. 企业账号模板含商机阶段、输单原因、客户生命周期、合同到期日等列；字典可选值以「示例数据」表为准。在「客户导入模板」中每列填一项名称或编码即可；误粘整段说明时会尝试识别首个有效项。合同到期日支持 yyyy-MM-dd、yyyy/MM/dd、yyyy.MM.dd 等常见格式。
              </p>
              <p v-if="enterpriseCrmEnabled">
                6. 「输单原因」仅在「商机阶段」为输单时写入：两列需同时填写且与字典一致；若字典里输单阶段编码不是默认 LOSE，请让管理员在后台配置 crm.business-dict-codes.opportunity-stage-lose。
              </p>
            </div>
          </template>
        </el-alert>
        
        <el-upload
          ref="uploadRef"
          :auto-upload="false"
          :on-change="handleFileChange"
          :file-list="fileList"
          :limit="1"
          accept=".xlsx,.xls"
          drag
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将文件拖到此处，或<em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              只能上传 .xlsx/.xls 文件
            </div>
          </template>
        </el-upload>
      </div>
      
      <template #footer>
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleImportSubmit" :loading="importLoading">
          开始导入
        </el-button>
      </template>
    </el-dialog>

    <!-- 地区选择弹窗 -->
    <el-dialog
      v-model="regionDialogVisible"
      title="选择所在地区"
      width="600px"
      @close="handleRegionDialogClose"
    >
      <div class="region-dialog-content">
        <el-form label-width="80px">
          <el-form-item label="省份">
            <el-select
              v-model="regionDialogForm.provinceId"
              placeholder="请选择省份"
              clearable
              style="width: 100%"
              @change="handleRegionProvinceChange"
            >
              <el-option
                v-for="item in regionDialogProvinceOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="城市">
            <el-select
              v-model="regionDialogForm.cityId"
              placeholder="请先选择省份"
              clearable
              style="width: 100%"
              :disabled="!regionDialogForm.provinceId"
              @change="handleRegionCityChange"
            >
              <el-option
                v-for="item in regionDialogCityOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="区县" required>
            <el-select
              v-model="regionDialogForm.districtId"
              placeholder="请先选择城市"
              clearable
              style="width: 100%"
              :disabled="!regionDialogForm.cityId"
            >
              <el-option
                v-for="item in regionDialogDistrictOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <el-button @click="regionDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :disabled="!regionDialogForm.districtId"
          @click="handleConfirmRegion"
        >
          确定
        </el-button>
      </template>
    </el-dialog>

    <!-- 定位选择器弹窗 -->
    <el-dialog
      v-model="locationDialogVisible"
      title="选择位置"
      width="900px"
      destroy-on-close
      @close="handleLocationDialogClose"
    >
      <div class="location-picker">
        <!-- 搜索框 -->
        <div class="location-search">
          <el-input
            v-model="locationSearchKeyword"
            placeholder="搜索地点"
            clearable
            @keyup.enter="handleLocationSearch"
          >
            <template #append>
              <el-button :icon="Search" @click="handleLocationSearch" :loading="locationSearchLoading">
                搜索
              </el-button>
            </template>
          </el-input>
        </div>

        <!-- 搜索结果列表 -->
        <div v-if="locationSearchResults.length > 0" class="location-results">
          <div
            v-for="(item, index) in locationSearchResults"
            :key="index"
            class="location-result-item"
            @click="selectLocationResult(item)"
          >
            <div class="result-name">{{ item.name }}</div>
            <div class="result-address">{{ item.fullAddress }}</div>
          </div>
        </div>

        <!-- 地图容器 -->
        <div class="location-map-container">
          <div id="customer-location-map" class="location-map">
            <div class="map-placeholder">
              <div class="map-placeholder-text">地图加载中...</div>
              <div class="map-placeholder-tip">提示：请使用搜索功能或定位按钮选择位置</div>
            </div>
          </div>
          <div class="map-tip">地图数据来源：天地图 Leaflet</div>
        </div>

        <!-- 当前选择的位置信息 -->
        <div v-if="selectedLocation" class="selected-location-info">
          <el-descriptions :column="1" border size="small">
            <el-descriptions-item label="地址">
              {{ selectedLocation.address || '未获取到地址' }}
            </el-descriptions-item>
            <el-descriptions-item label="经纬度">
              {{ selectedLocation.latitude.toFixed(6) }}, {{ selectedLocation.longitude.toFixed(6) }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="locationDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmLocation" :disabled="!selectedLocation">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 导入记录对话框 -->
    <el-dialog
      v-model="importRecordDialogVisible"
      title="导入记录"
      width="800px"
    >
      <el-table
        v-loading="importRecordLoading"
        :data="importRecordList"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="importTime" label="导入时间" width="180">
          <template #default="{ row }">
            {{ formatDateTime(row.importTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="totalCount" label="总条数" width="100" align="center" />
        <el-table-column prop="successCount" label="成功条数" width="100" align="center">
          <template #default="{ row }">
            <span style="color: #67c23a">{{ row.successCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="failCount" label="失败条数" width="100" align="center">
          <template #default="{ row }">
            <span style="color: #f56c6c">{{ row.failCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template #default="{ row }">
            <el-button
              v-if="row.failCount > 0 && row.failExcelUrl"
              type="primary"
              size="small"
              @click="handleDownloadFailExcel(row.failExcelUrl)"
            >
              下载失败Excel
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination" style="margin-top: 20px">
        <el-pagination
          v-model:current-page="importRecordPage"
          v-model:page-size="importRecordPageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="importRecordTotal"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleImportRecordSizeChange"
          @current-change="handleImportRecordPageChange"
        />
      </div>
    </el-dialog>

    <!-- 客户操作日志 -->
    <el-dialog
      v-model="customerLogDialogVisible"
      :title="customerLogDialogTitle"
      width="920px"
      class="customer-log-dialog"
      destroy-on-close
      @closed="handleCustomerLogDialogClosed"
    >
      <div v-loading="customerLogLoading" class="customer-log-list-wrap">
        <div v-if="!customerLogDisplayList.length" class="customer-log-empty">暂无操作记录</div>
        <div v-else class="customer-log-list">
          <div v-for="item in customerLogDisplayList" :key="item.id" class="customer-log-card">
            <div
              v-for="(line, index) in item.lines"
              :key="`${item.id}-${index}`"
              :class="['customer-log-line', index === 0 ? 'is-main' : 'is-sub']"
            >
              {{ line }}
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button type="primary" @click="customerLogDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, onActivated, nextTick, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Download, Upload, UploadFilled, Document, Location, Search } from '@element-plus/icons-vue'
import { getCurrentLocation, reverseGeocode, searchLocation } from '../utils/tianditu'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import {
  getCustomerList,
  getCustomerDetail,
  getCustomerOperationLogs,
  addCustomer,
  updateCustomer,
  exportCustomerList,
  downloadCustomerImportTemplate,
  importCustomerList,
  getCustomerGroupList,
  getIntentionLevels,
  getRegionChildren,
  getImportRecords,
  getCustomerCrmMeta
} from '../api/salesman'
import { checkQuotaWithLocalFallback, QUOTA_TYPE } from '../utils/quotaCheck'

const route = useRoute()
const router = useRouter()

const getCompanyId = () => {
  try {
    const userInfoStr = localStorage.getItem('userInfo')
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr)
      return userInfo.companyId || null
    }
  } catch (e) {
    console.warn('解析用户信息失败', e)
  }
  return null
}

const crmMeta = ref({
  enterpriseCrmEnabled: false,
  opportunityStages: {},
  lifecycleStatuses: {},
  loseReasons: {},
  opportunityStageLoseCode: '',
  opportunityStageWinCode: ''
})

const enterpriseCrmEnabled = computed(() => !!crmMeta.value?.enterpriseCrmEnabled)
const showPublicSeaButton = computed(() => !!(getCompanyId() && crmMeta.value?.publicSeaEnabled))

const crmStageOptions = computed(() => {
  const m = crmMeta.value?.opportunityStages || {}
  return Object.keys(m).map((code) => ({ value: code, label: m[code] || code }))
})

const crmLifecycleOptions = computed(() => {
  const m = crmMeta.value?.lifecycleStatuses || {}
  return Object.keys(m).map((code) => ({ value: code, label: m[code] || code }))
})

const crmLoseReasonOptions = computed(() => {
  const m = crmMeta.value?.loseReasons || {}
  return Object.keys(m).map((code) => ({ value: code, label: m[code] || code }))
})

const loadCrmMeta = async () => {
  if (!getCompanyId()) return
  try {
    const res = await getCustomerCrmMeta()
    if (res.code === '000000' && res.data) {
      crmMeta.value = { ...crmMeta.value, ...res.data }
    }
  } catch (e) {
    console.warn('加载 CRM 元数据失败', e)
  }
}

// 数据
const loading = ref(false)
const customerList = ref([])
const total = ref(0)
const exportLoading = ref(false)
const templateLoading = ref(false)
// 上次导出时间，用于限流
const lastExportTime = ref(0)
// 导出限流间隔时间（毫秒），3秒内不允许重复导出
const EXPORT_THROTTLE_INTERVAL = 3000
const queryParams = reactive({
  customerName: '',
  contactPhone: '',
  intentionLevel: '',
  groupId: '',
  provinceId: null,
  cityId: null,
  regionId: null,
  createTimeStart: '',
  createTimeEnd: '',
  opportunityStage: '',
  lifecycleStatus: '',
  page: 1,
  pageSize: 10
})

// 创建时间范围（用于日期选择器）
const createTimeRange = ref([])

// 筛选表单展开/收起状态（已移除收起功能，始终展开）
// const searchFormExpanded = ref(true) // 已废弃

// 选项数据
const groupOptions = ref([])
const intentionLevelOptions = ref([])
const provinceOptions = ref([])
const cityOptions = ref([])
const districtOptions = ref([])

// 导入相关
const importDialogVisible = ref(false)
const importLoading = ref(false)
const fileList = ref([])
const uploadRef = ref(null)
const currentFile = ref(null)

// 导入记录相关
const importRecordDialogVisible = ref(false)
const importRecordLoading = ref(false)
const importRecordList = ref([])
const importRecordTotal = ref(0)
const importRecordPage = ref(1)
const importRecordPageSize = ref(10)

// 公海相关
const publicSeaDialogVisible = ref(false)
const publicSeaLoading = ref(false)
const publicSeaList = ref([])
const publicSeaTotal = ref(0)
const publicSeaQuery = reactive({
  customerName: '',
  contactPhone: '',
  page: 1,
  pageSize: 10
})

// 定位相关
const locationLoading = ref(false)
const locationDialogVisible = ref(false)
const locationSearchKeyword = ref('')
const locationSearchLoading = ref(false)
const locationSearchResults = ref([])
const selectedLocation = ref(null)
let locationMap = null
let locationMarker = null

// 地图选点限流相关
const lastMapClickTime = ref(0)
const firstThrottledClickTime = ref(0) // 首次被限流的点击时间
const MAP_CLICK_THROTTLE_INTERVAL = 1000 // 地图点击限流间隔（毫秒），1秒内不允许重复点击
const MAP_CLICK_COOLDOWN_SECONDS = 5 // 冷却时间（秒），提示用户等待的秒数
let searchDebounceTimer = null // 搜索防抖定时器
const SEARCH_DEBOUNCE_DELAY = 500 // 搜索防抖延迟（毫秒）

// 对话框
const dialogVisible = ref(false)
const dialogTitle = ref('新增客户')
const isEdit = ref(false)
const isView = ref(false)
const detailLoading = ref(false)

/** 客户操作日志（公海/归属/资料变更等） */
const customerLogDialogVisible = ref(false)
const customerLogDialogTitle = ref('客户日志')
const customerLogLoading = ref(false)
const customerLogList = ref([])
const customerLogCustomerId = ref(null)

const customerFormRef = ref(null)
const customerForm = reactive({
  customerId: null,
  customerName: '',
  customerPosition: '',
  contactPhone: '',
  followUpReminder: 0,
  provinceId: null,
  cityId: null,
  regionId: null,
  regionName: '',
  address: '',
  companyName: '',
  groupId: '',
  groupName: '',
  customerSource: '',
  customerSourcePhone: '',
  customerType: 'normal',
  intentionLevel: '',
  detailInfo: '',
  remark: '',
  createTime: null,
  updateTime: null,
  opportunityStage: '',
  loseReason: '',
  lifecycleStatus: '',
  contractExpireDate: '',
  addFollowOnOpportunityStageChange: false
})

// 表单地区选择相关（保留用于编辑时回显）
const formProvinceOptions = ref([])
const formCityOptions = ref([])
const formDistrictOptions = ref([])

// 地区选择弹窗相关
const regionDialogVisible = ref(false)
const regionDialogProvinceOptions = ref([])
const regionDialogCityOptions = ref([])
const regionDialogDistrictOptions = ref([])
const regionDialogForm = reactive({
  provinceId: null,
  cityId: null,
  districtId: null
})

// 已选择地区的文本显示
const selectedRegionText = computed(() => {
  if (!customerForm.regionId) {
    return ''
  }
  // 从已加载的选项中查找显示文本
  if (customerForm.regionId && formDistrictOptions.value.length > 0) {
    const district = formDistrictOptions.value.find(d => d.id === customerForm.regionId)
    if (district) {
      const city = formCityOptions.value.find(c => c.id === customerForm.cityId)
      const province = formProvinceOptions.value.find(p => p.id === customerForm.provinceId)
      if (province && city) {
        return `${province.name}/${city.name}/${district.name}`
      }
    }
  }
  // 如果找不到，尝试使用 regionName
  if (customerForm.regionName) {
    return customerForm.regionName
  }
  return '已选择地区'
})

const customerFormRules = {
  customerName: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
  contactPhone: [
    { required: true, message: '请输入客户手机', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
  ],
  detailInfo: [{ required: true, message: '请输入客户信息', trigger: 'blur' }],
  customerSourcePhone: [
    { 
      validator: (rule, value, callback) => {
        if (value && value.trim()) {
          if (!/^1[3-9]\d{9}$/.test(value.trim())) {
            callback(new Error('关联客户手机号格式不正确'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  intentionLevel: [
    {
      validator: (rule, value, callback) => {
        // 如果客户类型是意向客户，则意向等级必填
        if (customerForm.customerType === 'intention') {
          if (!value || (typeof value === 'string' && value.trim() === '')) {
            callback(new Error('请选择意向等级'))
          } else {
            callback()
          }
        } else {
          // 普通客户不需要验证意向等级
          callback()
        }
      },
      trigger: 'change'
    }
  ]
}

// 方法
const getIntentionLevelName = (level) => {
  // 处理空值情况：null、undefined、空字符串都视为"暂无"
  if (!level || (typeof level === 'string' && level.trim() === '')) {
    return '暂无'
  }
  // 从字典中查找，使用 dataCode 匹配
  const option = intentionLevelOptions.value.find(item => 
    item.dataCode === level || 
    item.dataCode?.toUpperCase() === level?.toUpperCase() ||
    item.dataCode?.toLowerCase() === level?.toLowerCase()
  )
  if (option) {
    return option.dataName
  }
  // 如果找不到匹配项，使用默认的中文映射（兜底方案）
  const defaultMap = {
    'INTENTION': '意向',
    'HIGH': '高',
    'MEDIUM': '中',
    'LOW': '低',
    '高': '高',
    '中': '中',
    '低': '低'
  }
  // 支持大小写不敏感的匹配
  const upperLevel = level.toUpperCase()
  return defaultMap[upperLevel] || defaultMap[level] || level
}

const getIntentionLevelType = (level) => {
  // 处理空值情况：null、undefined、空字符串都返回'info'（灰色标签）
  if (!level || (typeof level === 'string' && level.trim() === '')) {
    return 'info'
  }
  const option = intentionLevelOptions.value.find(item => 
    item.dataCode === level || 
    item.dataCode?.toUpperCase() === level?.toUpperCase() ||
    item.dataCode?.toLowerCase() === level?.toLowerCase()
  )
  if (option) {
    const name = option.dataName || ''
    if (name.includes('高')) return 'danger'
    if (name.includes('中')) return 'warning'
    if (name.includes('低')) return 'info'
  }
  return 'info'
}

const formatDateTime = (dateTime) => {
  if (!dateTime) return '-'
  const date = new Date(dateTime)
  return date.toLocaleString('zh-CN')
}

const loadCustomerList = async () => {
  loading.value = true
  try {
    // 构建查询参数，确保空字符串不传递
    const params = {
      page: queryParams.page,
      pageSize: queryParams.pageSize
    }
    if (queryParams.customerName) {
      params.customerName = queryParams.customerName
    }
    if (queryParams.contactPhone) {
      params.contactPhone = queryParams.contactPhone
    }
    if (queryParams.intentionLevel) {
      params.intentionLevel = queryParams.intentionLevel
    }
    if (queryParams.groupId) {
      params.groupId = queryParams.groupId
    }
    if (queryParams.followUpReminder !== null && queryParams.followUpReminder !== undefined) {
      params.followUpReminder = queryParams.followUpReminder
    }

    // 所在地区筛选：优先使用区，其次市，最后省，避免同时传多个级别导致后端只按市过滤
    const { provinceId, cityId, regionId } = queryParams
    if (regionId) {
      params.regionId = regionId
    } else if (cityId) {
      params.cityId = cityId
    } else if (provinceId) {
      params.provinceId = provinceId
    }

    if (queryParams.createTimeStart) {
      params.createTimeStart = queryParams.createTimeStart
    }
    if (queryParams.createTimeEnd) {
      params.createTimeEnd = queryParams.createTimeEnd
    }
    if (enterpriseCrmEnabled.value && queryParams.opportunityStage) {
      params.opportunityStage = queryParams.opportunityStage
    }
    if (enterpriseCrmEnabled.value && queryParams.lifecycleStatus) {
      params.lifecycleStatus = queryParams.lifecycleStatus
    }
    console.log('查询参数:', params)
    const res = await getCustomerList(params)
    if (res.code === '000000') {
      customerList.value = res.data?.records || res.data?.list || []
      total.value = res.data?.total || 0
    }
  } catch (error) {
    console.error('获取客户列表失败:', error)
    ElMessage.error('获取客户列表失败')
  } finally {
    loading.value = false
  }
}

const handleSearch = () => {
  // 处理创建时间范围
  if (createTimeRange.value && createTimeRange.value.length === 2) {
    queryParams.createTimeStart = createTimeRange.value[0]
    queryParams.createTimeEnd = createTimeRange.value[1]
  } else {
    queryParams.createTimeStart = ''
    queryParams.createTimeEnd = ''
  }
  
  // 如果搜索输入框（客户姓名、客户手机）为空，不清空其他筛选条件
  // 只重置页码，保留所有筛选条件（包括客户分组、意向等级、地区等）
  queryParams.page = 1
  loadCustomerList()
}

// 加载分组选项
const loadGroupOptions = async () => {
  try {
    const res = await getCustomerGroupList()
    console.log('客户分组接口响应:', res)
    if (res.code === '000000') {
      groupOptions.value = res.data || []
      console.log('客户分组数据加载成功:', groupOptions.value)
      if (!groupOptions.value || groupOptions.value.length === 0) {
        console.warn('客户分组数据为空，可能是该业务员还没有创建分组')
      }
    } else {
      console.error('加载分组列表失败:', res.message || res.msg)
      ElMessage.warning('加载客户分组失败: ' + (res.message || res.msg || '未知错误'))
    }
  } catch (error) {
    console.error('加载分组列表失败:', error)
    ElMessage.error('加载客户分组失败: ' + (error.message || '网络错误'))
  }
}

// 加载意向等级选项
const loadIntentionLevels = async () => {
  try {
    const res = await getIntentionLevels()
    if (res.code === '000000') {
      intentionLevelOptions.value = res.data || []
      console.log('意向等级数据加载成功:', intentionLevelOptions.value)
      if (!intentionLevelOptions.value || intentionLevelOptions.value.length === 0) {
        ElMessage.warning('意向等级字典数据为空')
      }
    } else {
      console.error('加载意向等级列表失败:', res.message || res.msg)
      ElMessage.warning('加载意向等级失败: ' + (res.message || res.msg || '未知错误'))
    }
  } catch (error) {
    console.error('加载意向等级列表失败:', error)
    ElMessage.error('加载意向等级失败: ' + (error.message || '网络错误'))
  }
}

// 加载省份列表
const loadProvinceOptions = async () => {
  try {
    const res = await getRegionChildren(0)
    if (res.code === '000000') {
      provinceOptions.value = res.data || []
      console.log('省份数据加载成功:', provinceOptions.value)
      if (!provinceOptions.value || provinceOptions.value.length === 0) {
        ElMessage.warning('省份数据为空')
      }
    } else {
      console.error('加载省份列表失败:', res.message || res.msg)
      ElMessage.warning('加载省份列表失败: ' + (res.message || res.msg || '未知错误'))
    }
  } catch (error) {
    console.error('加载省份列表失败:', error)
    ElMessage.error('加载省份列表失败: ' + (error.message || '网络错误'))
  }
}

// 加载城市列表
const loadCityOptions = async (provinceId) => {
  if (!provinceId) {
    cityOptions.value = []
    return
  }
  try {
    const res = await getRegionChildren(provinceId)
    if (res.code === '000000') {
      cityOptions.value = res.data || []
    }
  } catch (error) {
    console.error('加载城市列表失败:', error)
    cityOptions.value = []
  }
}

// 加载区域列表
const loadDistrictOptions = async (cityId) => {
  if (!cityId) {
    districtOptions.value = []
    return
  }
  try {
    const res = await getRegionChildren(cityId)
    if (res.code === '000000') {
      districtOptions.value = res.data || []
    }
  } catch (error) {
    console.error('加载区域列表失败:', error)
    districtOptions.value = []
  }
}

// 省份变化
const handleProvinceChange = (provinceId) => {
  queryParams.cityId = null
  queryParams.regionId = null
  cityOptions.value = []
  districtOptions.value = []
  if (provinceId) {
    loadCityOptions(provinceId)
  }
}

// 城市变化
const handleCityChange = (cityId) => {
  queryParams.regionId = null
  districtOptions.value = []
  if (cityId) {
    loadDistrictOptions(cityId)
  }
}

// 切换筛选表单展开/收起状态（已移除收起功能）
// const toggleSearchForm = () => {
//   searchFormExpanded.value = !searchFormExpanded.value
//   // 收起/展开时不清除客户分组条件，保持 queryParams.groupId 不变
// } // 已废弃

const onOpportunityStageChange = () => {
  const lose = crmMeta.value?.opportunityStageLoseCode || 'LOSE'
  if (customerForm.opportunityStage !== lose) {
    customerForm.loseReason = ''
  }
  customerForm.addFollowOnOpportunityStageChange = false

  // 赢单后引导登记成交台账（PC：确认框 + 跳转，需已保存的客户 ID）
  if (!enterpriseCrmEnabled.value || isView.value || !isEdit.value || !customerForm.customerId) {
    return
  }
  const win = crmMeta.value?.opportunityStageWinCode || 'WIN'
  if (customerForm.opportunityStage !== win) {
    return
  }
  nextTick(() => {
    ElMessageBox.confirm(
      '客户商机阶段已设为赢单，建议尽快登记成交台账，以便统计业绩；企业用户还可在台账中勾选回访计划，生成对应日期的回访待办。',
      '是否前往登记成交台账？',
      {
        confirmButtonText: '去登记',
        cancelButtonText: '稍后',
        type: 'success',
        distinguishCancelAndClose: true
      }
    )
      .then(() => {
        router.push({
          name: 'SalesmanDealRecordManagement',
          query: {
            openAdd: '1',
            customerId: String(customerForm.customerId),
            customerName: encodeURIComponent(customerForm.customerName || '')
          }
        })
      })
      .catch(() => {})
  })
}

const handleReset = () => {
  queryParams.customerName = ''
  queryParams.contactPhone = ''
  queryParams.intentionLevel = ''
  queryParams.groupId = ''
  queryParams.followUpReminder = null
  queryParams.provinceId = null
  queryParams.cityId = null
  queryParams.regionId = null
  queryParams.createTimeStart = ''
  queryParams.createTimeEnd = ''
  queryParams.opportunityStage = ''
  queryParams.lifecycleStatus = ''
  queryParams.page = 1
  createTimeRange.value = []
  cityOptions.value = []
  districtOptions.value = []
  loadCustomerList()
}

const handleCreate = async () => {
  // 先检查客户额度
  const result = await checkQuotaWithLocalFallback(QUOTA_TYPE.CUSTOMER, {
    allowLocalOperation: false,
    operationName: '新增客户'
  })
  
  if (!result.allowed) {
    // 额度已超限，不允许新增
    return
  }
  
  // 额度未超限，显示新增客户弹窗
  dialogTitle.value = '新增客户'
  isEdit.value = false
  isView.value = false
  // 重置表单
  Object.assign(customerForm, {
    customerId: null,
    customerName: '',
    customerPosition: '',
    contactPhone: '',
    followUpReminder: 0,
    provinceId: null,
    cityId: null,
    regionId: null,
    regionName: '',
    address: '',
    companyName: '',
    groupId: '',
    groupName: '',
    customerSource: '',
    customerSourcePhone: '',
    customerType: 'normal',
    intentionLevel: '',
    detailInfo: '',
    remark: '',
    createTime: null,
    updateTime: null,
    opportunityStage: '',
    loseReason: '',
    lifecycleStatus: '',
    contractExpireDate: '',
    addFollowOnOpportunityStageChange: false
  })
  // 重置地区选择
  formCityOptions.value = []
  formDistrictOptions.value = []
  dialogVisible.value = true
}

const getCustomerLogOperatorLabel = (row) => {
  const operatorId = row?.operatorUserId
  const name = row?.operatorName
  if (operatorId === 0 || operatorId === '0') return '系统'
  if (name && String(name).trim()) return String(name).trim()
  if (operatorId != null && operatorId !== '') return `用户#${operatorId}`
  return '系统'
}

const getCustomerLogSalesmanLabel = (id, name) => {
  if (name && String(name).trim()) return String(name).trim()
  if (id != null && id !== '') return `业务员#${id}`
  return '公海'
}

const buildCustomerLogLines = (row) => {
  const timeText = formatDateTime(row?.createTime)
  const who = getCustomerLogOperatorLabel(row)
  const customerName = row?.customerName || row?.contactName || row?.customerDisplayName || '该客户'
  const partySalesman = row?.partySalesmanName || (row?.partySalesmanId != null ? `业务员#${row.partySalesmanId}` : '')
  const ownerBefore = getCustomerLogSalesmanLabel(row?.ownerBeforeSalesmanId, row?.ownerBeforeSalesmanName)
  const ownerAfter = getCustomerLogSalesmanLabel(row?.ownerAfterSalesmanId, row?.ownerAfterSalesmanName)
  const remark = (row?.remark || '').trim()
  const opType = row?.opType || ''
  const lines = []

  const pushRemarkIfNeeded = () => {
    if (!remark || opType === 'INFO_UPDATE') return
    lines.push(remark)
  }

  switch (opType) {
    case 'CLAIM_FROM_POOL':
      lines.push(`${timeText}，${who}认领了「${customerName}」。`)
      if (partySalesman) lines.push(`该客户之前归属于「${partySalesman}」。`)
      pushRemarkIfNeeded()
      break
    case 'MANUAL_RELEASE_POOL':
      lines.push(`${timeText}，${who}把「${customerName}」退回了公海。`)
      pushRemarkIfNeeded()
      break
    case 'AUTO_RECYCLE_POOL':
      lines.push(`${timeText}，${who}将「${customerName}」自动退回了公海。`)
      pushRemarkIfNeeded()
      break
    case 'INFO_UPDATE':
      lines.push(`${timeText}，${who}修改了客户「${customerName}」的资料。`)
      if (remark) lines.push(remark)
      break
    case 'CUSTOMER_CREATE':
      lines.push(`${timeText}，${who}新建了客户「${customerName}」。`)
      pushRemarkIfNeeded()
      break
    case 'ADMIN_ASSIGN_POOL':
      lines.push(`${timeText}，${who}将客户「${customerName}」分配给了「${ownerAfter}」。`)
      pushRemarkIfNeeded()
      break
    case 'OWNER_CHANGE':
      lines.push(`${timeText}，「${customerName}」的归属由「${ownerBefore}」变为「${ownerAfter}」。`)
      pushRemarkIfNeeded()
      break
    default:
      lines.push(`${timeText}，${who}对「${customerName}」进行了「${row?.opTypeLabel || opType || '操作'}」。`)
      if (ownerBefore !== '公海' || ownerAfter !== '公海') {
        lines.push(`归属由「${ownerBefore}」变为「${ownerAfter}」。`)
      } else if (partySalesman) {
        lines.push(`关联业务员：「${partySalesman}」。`)
      }
      pushRemarkIfNeeded()
      break
  }

  return lines.length ? lines : [`${timeText}，${who}操作了「${customerName}」。`]
}

const customerLogDisplayList = computed(() =>
  customerLogList.value.map((row) => ({
    id: row.id,
    lines: buildCustomerLogLines(row)
  }))
)

const loadCustomerOperationLogs = async (customerId) => {
  customerLogLoading.value = true
  customerLogList.value = []
  try {
    const res = await getCustomerOperationLogs(customerId)
    if (res.code === '000000') {
      customerLogList.value = Array.isArray(res.data) ? res.data : []
    } else {
      ElMessage.error(res.message || '加载客户日志失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('加载客户日志失败')
  } finally {
    customerLogLoading.value = false
  }
}

const handleOpenCustomerLog = async (row) => {
  if (!row?.id) return
  customerLogCustomerId.value = row.id
  const name = row.customerName || row.contactName || ''
  customerLogDialogTitle.value = name ? `客户日志 — ${name}（ID ${row.id}）` : `客户日志（ID ${row.id}）`
  customerLogDialogVisible.value = true
  await loadCustomerOperationLogs(row.id)
}

const handleCustomerLogDialogClosed = () => {
  customerLogList.value = []
  customerLogCustomerId.value = null
}

const handleView = async (row) => {
  detailLoading.value = true
  dialogVisible.value = true
  try {
    const res = await getCustomerDetail(row.id)
    if (res.code === '000000') {
      dialogTitle.value = '客户详情'
      isEdit.value = false
      isView.value = true
      // 清空旧数据
      Object.keys(customerForm).forEach(key => {
        customerForm[key] = null
      })
      // 填充新数据
      Object.assign(customerForm, res.data)
      customerForm.customerId = res.data.id
    } else {
      ElMessage.error(res.message || '获取客户详情失败')
      dialogVisible.value = false
    }
  } catch (error) {
    console.error('获取客户详情失败:', error)
    ElMessage.error('获取客户详情失败')
    dialogVisible.value = false
  } finally {
    detailLoading.value = false
  }
}

const handleEdit = async (row) => {
  detailLoading.value = true
  dialogVisible.value = true
  try {
    const res = await getCustomerDetail(row.id)
    if (res.code === '000000') {
      dialogTitle.value = '编辑客户'
      isEdit.value = true
      isView.value = false
      // 清空旧数据
      Object.keys(customerForm).forEach(key => {
        customerForm[key] = null
      })
      // 填充新数据
      Object.assign(customerForm, res.data)
      customerForm.customerId = res.data.id
      // 回显保存的「阶段变更记录跟进」偏好（勿在此覆盖为 false）
      if (customerForm.addFollowOnOpportunityStageChange == null) {
        customerForm.addFollowOnOpportunityStageChange = false
      }
      // 处理地区选择：优先使用 regionId，如果没有则通过 regionName 解析
      if (res.data.regionId) {
        // 如果后端返回了 regionId，需要通过 regionId 反向查找省市区
        // 这里先尝试通过 regionName 解析（更简单的方式）
        if (res.data.regionName) {
          const regionParts = res.data.regionName.split('/')
          if (regionParts.length >= 1) {
            // 查找省份
            const province = formProvinceOptions.value.find(p => p.name === regionParts[0])
            if (province) {
              customerForm.provinceId = province.id
              await loadFormCityOptions(province.id)
              if (regionParts.length >= 2) {
                // 查找城市
                const city = formCityOptions.value.find(c => c.name === regionParts[1])
                if (city) {
                  customerForm.cityId = city.id
                  await loadFormDistrictOptions(city.id)
                  if (regionParts.length >= 3) {
                    // 查找区县
                    const district = formDistrictOptions.value.find(d => d.name === regionParts[2])
                    if (district) {
                      customerForm.regionId = district.id
                    }
                  }
                }
              }
            }
          }
        }
      } else if (res.data.regionName) {
        // 如果没有 regionId，通过 regionName 解析
        const regionParts = res.data.regionName.split('/')
        if (regionParts.length >= 1) {
          // 查找省份
          const province = formProvinceOptions.value.find(p => p.name === regionParts[0])
          if (province) {
            customerForm.provinceId = province.id
            await loadFormCityOptions(province.id)
            if (regionParts.length >= 2) {
              // 查找城市
              const city = formCityOptions.value.find(c => c.name === regionParts[1])
              if (city) {
                customerForm.cityId = city.id
                await loadFormDistrictOptions(city.id)
                if (regionParts.length >= 3) {
                  // 查找区县
                  const district = formDistrictOptions.value.find(d => d.name === regionParts[2])
                  if (district) {
                    customerForm.regionId = district.id
                  }
                }
              }
            }
          }
        }
      }
      // 处理分组ID
      if (res.data.groupId && res.data.groupId.toString().trim() !== '') {
        customerForm.groupId = String(res.data.groupId)
      } else {
        customerForm.groupId = ''
      }
      // 处理重点跟进
      if (res.data.followUpReminder === undefined || res.data.followUpReminder === null) {
        customerForm.followUpReminder = 0
      }
    } else {
      ElMessage.error(res.message || '获取客户详情失败')
      dialogVisible.value = false
    }
  } catch (error) {
    console.error('获取客户详情失败:', error)
    ElMessage.error('获取客户详情失败')
    dialogVisible.value = false
  } finally {
    detailLoading.value = false
  }
}

const handleSubmit = async () => {
  if (!customerFormRef.value) return
  await customerFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        // 构建提交数据
        const submitData = {
          customerId: customerForm.customerId,
          customerName: customerForm.customerName,
          customerPosition: customerForm.customerPosition || null,
          contactPhone: customerForm.contactPhone,
          followUpReminder: customerForm.followUpReminder || 0,
          // 地区：明确传递值，支持清空操作
          // 如果 regionId 为 null、undefined 或空字符串，明确传递 null
          // eslint-disable-next-line no-self-assign
          regionId: (customerForm.regionId != null && customerForm.regionId !== '') ? customerForm.regionId : null,
          address: customerForm.address || null,
          companyName: customerForm.companyName || null,
          // groupId 需要转换为字符串，因为后端期望 String 类型
          // 如果为空字符串或 undefined/null，明确传递 null（注意：空字符串也要传递 null）
          groupId: (customerForm.groupId && customerForm.groupId.toString().trim() !== '') ? String(customerForm.groupId) : null,
          // 同时传递分组名称，直接从下拉框选项获取
          groupName: (customerForm.groupId && customerForm.groupId.toString().trim() !== '')
            ? (groupOptions.value.find(g => String(g.id) === String(customerForm.groupId))?.groupName || null)
            : null,
          customerSource: customerForm.customerSource || null,
          customerSourcePhone: customerForm.customerSourcePhone ? customerForm.customerSourcePhone.trim() : null,
          customerType: customerForm.customerType || 'normal',
          // 如果是普通客户，意向等级必须为空
          intentionLevel: customerForm.customerType === 'normal' ? null : (customerForm.intentionLevel || null),
          detailInfo: customerForm.detailInfo || null,
          remark: customerForm.remark || null
        }
        if (enterpriseCrmEnabled.value) {
          const lose = crmMeta.value?.opportunityStageLoseCode || 'LOSE'
          submitData.opportunityStage = customerForm.opportunityStage || null
          submitData.loseReason = customerForm.opportunityStage === lose ? (customerForm.loseReason || null) : null
          submitData.lifecycleStatus = customerForm.lifecycleStatus || null
          submitData.contractExpireDate = customerForm.contractExpireDate || null
          submitData.addFollowOnOpportunityStageChange = !!customerForm.addFollowOnOpportunityStageChange
        }
        
        // 调试日志
        console.log('提交客户数据:', submitData)
        console.log('编辑模式:', isEdit.value)
        console.log('regionId:', submitData.regionId, '原始值:', customerForm.regionId)
        console.log('groupId:', submitData.groupId, '原始值:', customerForm.groupId)
        
        const res = isEdit.value
          ? await updateCustomer(submitData)
          : await addCustomer(submitData)
        if (res.code === '000000') {
          ElMessage.success(isEdit.value ? '更新成功' : '创建成功')
          dialogVisible.value = false
          loadCustomerList()
        }
        // 注意：如果 res.code !== '000000'，响应拦截器会显示错误消息并 reject，
        // 所以代码会进入 catch 块，不需要在这里再次显示错误消息
      } catch (error) {
        console.error('保存客户失败:', error)
        // 响应拦截器已经显示了错误消息（当 res.code !== '000000' 时），这里不需要再次显示
        // 如果 error.isBusinessError 为 true，说明是业务错误，响应拦截器已经显示过错误消息
        // 只有在网络错误或其他未通过响应拦截器处理的错误时才显示
        if (!error.isBusinessError && !error.response) {
          ElMessage.error(error.message || '保存客户失败')
        }
        // 如果 error.isBusinessError 为 true 或 error.response 存在，说明响应拦截器已经显示了错误消息，不需要再次显示
      }
    }
  })
}

const handleDialogClose = () => {
  customerFormRef.value?.resetFields()
  // 重置地区选择
  formCityOptions.value = []
  formDistrictOptions.value = []
}

// 表单地区选择相关方法
const loadFormCityOptions = async (provinceId) => {
  if (!provinceId) {
    formCityOptions.value = []
    return
  }
  try {
    const res = await getRegionChildren(provinceId)
    if (res.code === '000000') {
      formCityOptions.value = res.data || []
    }
  } catch (error) {
    console.error('加载城市列表失败:', error)
    formCityOptions.value = []
  }
}

const loadFormDistrictOptions = async (cityId) => {
  if (!cityId) {
    formDistrictOptions.value = []
    return
  }
  try {
    const res = await getRegionChildren(cityId)
    if (res.code === '000000') {
      formDistrictOptions.value = res.data || []
    }
  } catch (error) {
    console.error('加载区域列表失败:', error)
    formDistrictOptions.value = []
  }
}

// 地区选择弹窗相关方法
const handleOpenRegionDialog = () => {
  regionDialogVisible.value = true
  // 初始化弹窗数据：如果有已选择的地区，回显到弹窗
  if (customerForm.regionId && customerForm.cityId && customerForm.provinceId) {
    regionDialogForm.provinceId = customerForm.provinceId
    regionDialogForm.cityId = customerForm.cityId
    regionDialogForm.districtId = customerForm.regionId
    // 加载对应的选项
    loadRegionDialogCityOptions(customerForm.provinceId)
    loadRegionDialogDistrictOptions(customerForm.cityId)
  } else {
    // 重置弹窗表单
    regionDialogForm.provinceId = null
    regionDialogForm.cityId = null
    regionDialogForm.districtId = null
    regionDialogCityOptions.value = []
    regionDialogDistrictOptions.value = []
  }
}

const handleRegionDialogClose = () => {
  // 关闭弹窗时重置表单（但不影响主表单）
  regionDialogForm.provinceId = null
  regionDialogForm.cityId = null
  regionDialogForm.districtId = null
  regionDialogCityOptions.value = []
  regionDialogDistrictOptions.value = []
}

const handleRegionProvinceChange = (provinceId) => {
  regionDialogForm.cityId = null
  regionDialogForm.districtId = null
  regionDialogCityOptions.value = []
  regionDialogDistrictOptions.value = []
  if (provinceId) {
    loadRegionDialogCityOptions(provinceId)
  }
}

const handleRegionCityChange = (cityId) => {
  regionDialogForm.districtId = null
  regionDialogDistrictOptions.value = []
  if (cityId) {
    loadRegionDialogDistrictOptions(cityId)
  }
}

const loadRegionDialogCityOptions = async (provinceId) => {
  if (!provinceId) {
    regionDialogCityOptions.value = []
    return
  }
  try {
    const res = await getRegionChildren(provinceId)
    if (res.code === '000000') {
      regionDialogCityOptions.value = res.data || []
    }
  } catch (error) {
    console.error('加载城市列表失败:', error)
    regionDialogCityOptions.value = []
  }
}

const loadRegionDialogDistrictOptions = async (cityId) => {
  if (!cityId) {
    regionDialogDistrictOptions.value = []
    return
  }
  try {
    const res = await getRegionChildren(cityId)
    if (res.code === '000000') {
      regionDialogDistrictOptions.value = res.data || []
    }
  } catch (error) {
    console.error('加载区县列表失败:', error)
    regionDialogDistrictOptions.value = []
  }
}

const handleConfirmRegion = () => {
  if (!regionDialogForm.districtId) {
    ElMessage.warning('请选择区县')
    return
  }
  // 更新主表单的地区信息
  customerForm.provinceId = regionDialogForm.provinceId
  customerForm.cityId = regionDialogForm.cityId
  customerForm.regionId = regionDialogForm.districtId
  // 同时更新显示用的选项数据，以便 computed 能正确显示
  formProvinceOptions.value = regionDialogProvinceOptions.value
  formCityOptions.value = regionDialogCityOptions.value
  formDistrictOptions.value = regionDialogDistrictOptions.value
  // 设置地区名称显示（从选项中查找）
  const province = regionDialogProvinceOptions.value.find(p => p.id === regionDialogForm.provinceId)
  const city = regionDialogCityOptions.value.find(c => c.id === regionDialogForm.cityId)
  const district = regionDialogDistrictOptions.value.find(d => d.id === regionDialogForm.districtId)
  if (province && city && district) {
    customerForm.regionName = `${province.name}/${city.name}/${district.name}`
  }
  regionDialogVisible.value = false
  ElMessage.success('地区选择成功')
}

const handleClearRegion = () => {
  customerForm.provinceId = null
  customerForm.cityId = null
  customerForm.regionId = null
  customerForm.regionName = ''
  formCityOptions.value = []
  formDistrictOptions.value = []
  ElMessage.success('已清除地区选择')
}

// 客户类型变化处理
const handleCustomerTypeChange = (value) => {
  // 如果选择普通客户，清空意向等级
  if (value === 'normal') {
    customerForm.intentionLevel = ''
    // 清除意向等级的验证错误
    if (customerFormRef.value) {
      customerFormRef.value.clearValidate('intentionLevel')
    }
  } else if (value === 'intention') {
    // 如果选择意向客户，触发意向等级的验证
    if (customerFormRef.value) {
      nextTick(() => {
        customerFormRef.value.validateField('intentionLevel')
      })
    }
  }
}

const handleSizeChange = (val) => {
  queryParams.pageSize = val
  queryParams.page = 1
  loadCustomerList()
}

const handlePageChange = (val) => {
  queryParams.page = val
  loadCustomerList()
}

// 导出客户
const handleExport = async () => {
  // 限流检查：如果正在导出，直接返回
  if (exportLoading.value) {
    return
  }
  
  // 限流检查：如果距离上次导出时间太短，提示用户
  const now = Date.now()
  const timeSinceLastExport = now - lastExportTime.value
  if (lastExportTime.value > 0 && timeSinceLastExport < EXPORT_THROTTLE_INTERVAL) {
    const remainingSeconds = Math.ceil((EXPORT_THROTTLE_INTERVAL - timeSinceLastExport) / 1000)
    ElMessage.warning(`导出操作过于频繁，请等待 ${remainingSeconds} 秒后再试`)
    return
  }
  
  try {
    exportLoading.value = true
    
    // 构建导出参数：与列表查询保持一致，但不包含分页参数
    const params = {}
    if (queryParams.customerName) {
      params.customerName = queryParams.customerName
    }
    if (queryParams.contactPhone) {
      params.contactPhone = queryParams.contactPhone
    }
    if (queryParams.intentionLevel) {
      params.intentionLevel = queryParams.intentionLevel
    }
    if (queryParams.groupId) {
      params.groupId = queryParams.groupId
    }
    if (queryParams.followUpReminder !== null && queryParams.followUpReminder !== undefined) {
      params.followUpReminder = queryParams.followUpReminder
    }

    // 所在地区筛选：优先区，其次市，最后省（与列表保持一致）
    const { provinceId, cityId, regionId } = queryParams
    if (regionId) {
      params.regionId = regionId
    } else if (cityId) {
      params.cityId = cityId
    } else if (provinceId) {
      params.provinceId = provinceId
    }

    if (queryParams.createTimeStart) {
      params.createTimeStart = queryParams.createTimeStart
    }
    if (queryParams.createTimeEnd) {
      params.createTimeEnd = queryParams.createTimeEnd
    }
    if (enterpriseCrmEnabled.value && queryParams.opportunityStage) {
      params.opportunityStage = queryParams.opportunityStage
    }
    if (enterpriseCrmEnabled.value && queryParams.lifecycleStatus) {
      params.lifecycleStatus = queryParams.lifecycleStatus
    }

    const blob = await exportCustomerList(params)
    
    // 检查返回的是否是Blob对象
    if (!(blob instanceof Blob)) {
      throw new Error('导出失败：返回数据格式错误')
    }
    
    // 创建下载链接
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `客户列表_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    
    ElMessage.success('导出成功')
    // 导出成功后才记录时间戳，失败时不限流
    lastExportTime.value = Date.now()
  } catch (error) {
    console.error('导出失败:', error)
    const errorMsg = error.message || '导出失败'
    // 如果是限流错误（数据量过大），使用warning提示
    if (errorMsg.includes('数据量过大') || errorMsg.includes('超过最大限制')) {
      ElMessage.warning(errorMsg)
    } else {
      ElMessage.error(errorMsg)
    }
    // 导出失败时不更新时间戳，允许用户立即重试
  } finally {
    exportLoading.value = false
  }
}

// 下载导入模板
const handleDownloadTemplate = async () => {
  templateLoading.value = true
  try {
    const blob = await downloadCustomerImportTemplate()
    
    // 创建下载链接
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = '客户导入模板.xlsx'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    
    ElMessage.success('模板下载成功')
  } catch (error) {
    console.error('下载模板失败:', error)
    ElMessage.error(error.message || '下载模板失败')
  } finally {
    templateLoading.value = false
  }
}

// 打开导入对话框
const handleImport = async () => {
  // 先检查客户额度
  const result = await checkQuotaWithLocalFallback(QUOTA_TYPE.CUSTOMER, {
    allowLocalOperation: true,
    operationName: '导入客户'
  })
  
  if (!result.allowed) {
    // 额度已超限，不允许导入
    return
  }
  
  importDialogVisible.value = true
  fileList.value = []
  currentFile.value = null
}

// 文件选择变化
const handleFileChange = (file) => {
  currentFile.value = file.raw
}

// 导入对话框关闭
const handleImportDialogClose = () => {
  fileList.value = []
  currentFile.value = null
  if (uploadRef.value) {
    uploadRef.value.clearFiles()
  }
}

// 提交导入
const handleImportSubmit = async () => {
  if (!currentFile.value) {
    ElMessage.warning('请先选择要导入的文件')
    return
  }
  
  const fileName = currentFile.value.name
  if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
    ElMessage.warning('文件格式不正确，请上传Excel文件（.xlsx或.xls）')
    return
  }
  
  importLoading.value = true
  try {
    const res = await importCustomerList(currentFile.value)
    
    // importCustomerList 使用 axios 直接调用，返回的是完整的 axios 响应对象
    // 结构：{ data: RestResult, status: 200, ... }
    // RestResult 结构：{ code: '000000', data: { total, success, fail, ... }, msg: ... }
    console.log('导入响应数据:', res)
    
    if (res && res.data) {
      // 检查是否是 RestResult 格式
      if (res.data.code === '000000' && res.data.data) {
        // 标准的 RestResult 格式
        const responseData = res.data.data
        const total = responseData.total ?? 0
        const success = responseData.success ?? 0
        const fail = responseData.fail ?? 0
        const failExcelUrl = responseData.failExcelUrl
        
        // 显示导入结果弹窗
        let message = `导入完成！\n总条数：${total}\n成功条数：${success}\n失败条数：${fail}`
        
        if (fail > 0 && failExcelUrl) {
          message += `\n\n失败数据已生成Excel文件，可点击"下载失败Excel"按钮下载查看。`
        }
        
        ElMessageBox.alert(
          message,
          '导入结果',
          {
            type: fail > 0 ? 'warning' : 'success',
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: false
          }
        ).then(() => {
          // 如果有失败Excel，提供下载链接
          if (fail > 0 && failExcelUrl) {
            handleDownloadFailExcel(failExcelUrl)
          }
        })
        
        // 刷新列表
        loadCustomerList()
        // 关闭对话框
        importDialogVisible.value = false
      } else {
        // 如果不是标准格式，尝试直接使用 res.data
        console.warn('导入响应格式异常:', res.data)
        ElMessage.error('导入失败：响应数据格式异常')
      }
    } else {
      ElMessage.error('导入失败：未返回结果')
    }
  } catch (error) {
    console.error('导入失败:', error)
    const errorMsg = error.response?.data?.msg || error.message || '导入失败'
    if (errorMsg.includes('导入服务暂时不可用')) {
      ElMessage.error('导入服务暂时不可用，请稍后再试~')
    } else {
      ElMessage.error(errorMsg)
    }
  } finally {
    importLoading.value = false
  }
}

// 打开导入记录对话框
const handleImportRecords = () => {
  importRecordDialogVisible.value = true
  loadImportRecords()
}

// 打开客户公海
const handlePublicSea = () => {
  if (!showPublicSeaButton.value) {
    ElMessage.warning('当前账号未绑定企业，无法使用客户公海')
    return
  }
  publicSeaDialogVisible.value = true
  publicSeaQuery.page = 1
  loadPublicSeaList()
}

// 加载公海客户列表（仅启用客户）
const loadPublicSeaList = async () => {
  publicSeaLoading.value = true
  try {
    const params = {
      page: publicSeaQuery.page,
      pageSize: publicSeaQuery.pageSize,
      publicSeaOnly: true,
      publicSeaCustomerStatus: 0
    }
    if (publicSeaQuery.customerName) {
      params.customerName = publicSeaQuery.customerName
    }
    if (publicSeaQuery.contactPhone) {
      params.contactPhone = publicSeaQuery.contactPhone
    }
    const res = await getCustomerList(params)
    if (res.code === '000000') {
      publicSeaList.value = res.data?.records || res.data?.list || []
      publicSeaTotal.value = res.data?.total || 0
    }
  } catch (error) {
    console.error('获取公海客户失败:', error)
    ElMessage.error('获取公海客户失败')
  } finally {
    publicSeaLoading.value = false
  }
}

const handlePublicSeaSearch = () => {
  publicSeaQuery.page = 1
  loadPublicSeaList()
}

const handlePublicSeaReset = () => {
  publicSeaQuery.customerName = ''
  publicSeaQuery.contactPhone = ''
  publicSeaQuery.page = 1
  loadPublicSeaList()
}

const handlePublicSeaSizeChange = (val) => {
  publicSeaQuery.pageSize = val
  publicSeaQuery.page = 1
  loadPublicSeaList()
}

const handlePublicSeaPageChange = (val) => {
  publicSeaQuery.page = val
  loadPublicSeaList()
}

// 加载导入记录
const loadImportRecords = async () => {
  importRecordLoading.value = true
  try {
    const res = await getImportRecords({
      page: importRecordPage.value,
      pageSize: importRecordPageSize.value
    })
    if (res.code === '000000') {
      importRecordList.value = res.data?.records || []
      importRecordTotal.value = res.data?.total || 0
    }
  } catch (error) {
    console.error('获取导入记录失败:', error)
    ElMessage.error('获取导入记录失败')
  } finally {
    importRecordLoading.value = false
  }
}

// 导入记录分页大小变化
const handleImportRecordSizeChange = (val) => {
  importRecordPageSize.value = val
  importRecordPage.value = 1
  loadImportRecords()
}

// 导入记录页码变化
const handleImportRecordPageChange = (val) => {
  importRecordPage.value = val
  loadImportRecords()
}

// 下载失败Excel
const handleDownloadFailExcel = async (url) => {
  try {
    const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
    const token = localStorage.getItem('accessToken')
    
    const response = await fetch(`${baseURL}${url}`, {
      method: 'GET',
      headers: {
        'Authorization': token ? `Bearer ${token}` : ''
      }
    })
    
    if (!response.ok) {
      throw new Error('下载失败')
    }
    
    const blob = await response.blob()
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = `客户导入失败记录_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(downloadUrl)
    
    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载失败Excel失败:', error)
    ElMessage.error('下载失败Excel失败')
  }
}

// 检查并打开详情的公共函数
const checkAndOpenDetail = async () => {
  if (route.query.id) {
    const customerId = route.query.id
    // 直接通过 id 调用接口获取详情
    try {
      await handleView({ id: customerId })
      // 清除路由参数，避免刷新时重复触发
      router.replace({ path: route.path, query: {} })
    } catch (error) {
      console.error('获取客户详情失败:', error)
      ElMessage.error('获取客户详情失败')
    }
  }
}

onMounted(async () => {
  // 检查并打开详情
  await checkAndOpenDetail()
  
  // 并行加载选项数据
  await Promise.all([
    loadGroupOptions(),
    loadIntentionLevels(),
    loadProvinceOptions(),
    loadCrmMeta()
  ])
  // 同时加载表单地区选项（用于新增/编辑）和弹窗地区选项
  formProvinceOptions.value = provinceOptions.value
  regionDialogProvinceOptions.value = provinceOptions.value
  // 加载客户列表
  await loadCustomerList()
})

// 页面激活时（keepAlive 缓存页面）
onActivated(async () => {
  // 检查并打开详情
  await checkAndOpenDetail()
})

// 打开定位选择器
const openLocationPicker = async () => {
  locationDialogVisible.value = true
  locationSearchKeyword.value = ''
  locationSearchResults.value = []
  selectedLocation.value = null

  await nextTick()
  initLocationMap()

  // 如果已有地址，尝试在地图上显示（需要先搜索）
  if (customerForm.address && customerForm.address.trim()) {
    // 可以尝试搜索当前地址，但这里先不实现，让用户手动搜索或点击地图
  } else {
    // 尝试获取当前位置（静默失败，不影响地图使用）
    locationLoading.value = true
    getCurrentLocation()
      .then(async (currentLocation) => {
        try {
          const addressData = await reverseGeocode(currentLocation.longitude, currentLocation.latitude)
          
          const location = {
            latitude: currentLocation.latitude,
            longitude: currentLocation.longitude,
            address: addressData.address || ''
          }
          updateMapLocation(location)
          selectedLocation.value = location
          ElMessage.success('定位成功')
        } catch (geocodeError) {
          console.error('逆地理编码失败:', geocodeError)
          // 即使逆地理编码失败，也使用定位的经纬度
          const location = {
            latitude: currentLocation.latitude,
            longitude: currentLocation.longitude,
            address: ''
          }
          updateMapLocation(location)
          selectedLocation.value = location
          ElMessage.info('已定位，但获取地址失败，可手动编辑')
        }
      })
      .catch((error) => {
        // 定位失败不影响地图使用，只记录日志，不显示错误提示
        console.log('获取当前位置失败（不影响使用）:', error.message)
      })
      .finally(() => {
        locationLoading.value = false
      })
  }
}

// 初始化地图
const initLocationMap = () => {
  const mapContainer = document.getElementById('customer-location-map')
  if (!mapContainer) return

  // 如果地图已存在，先清理
  if (locationMap) {
    locationMap.remove()
    locationMap = null
    locationMarker = null
  }

  // 清空容器
  mapContainer.innerHTML = ''

  const tiandituKey = process.env.VUE_APP_TIANDITU_KEY || 'f1d9eced233438796aa8c612693d7a52'
  
  // 默认中心点（北京）
  const defaultLng = 116.397428
  const defaultLat = 39.90923
  const defaultZoom = 13
  
  // 如果有选中的位置，使用选中位置的经纬度
  let centerLng = defaultLng
  let centerLat = defaultLat
  if (selectedLocation.value && selectedLocation.value.longitude && selectedLocation.value.latitude) {
    centerLng = selectedLocation.value.longitude
    centerLat = selectedLocation.value.latitude
  }
  
  // 创建 Leaflet 地图
  const map = L.map(mapContainer, {
    center: [centerLat, centerLng],
    zoom: defaultZoom,
    zoomControl: true
  })
  
  // 添加天地图瓦片图层
  // 使用天地图矢量地图（vec_w）
  const tiandituVecLayer = L.tileLayer(
    `https://t{s}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=${tiandituKey}`,
    {
      subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
      attribution: '&copy; 国家基础地理信息中心'
    }
  )
  
  // 添加天地图标注图层（cva_w）
  const tiandituAnnoLayer = L.tileLayer(
    `https://t{s}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=${tiandituKey}`,
    {
      subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
      attribution: '&copy; 国家基础地理信息中心'
    }
  )
  
  // 添加图层到地图
  tiandituVecLayer.addTo(map)
  tiandituAnnoLayer.addTo(map)
  
  // 修复 Leaflet 默认图标路径问题
  delete L.Icon.Default.prototype._getIconUrl
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
  })
  
  // 创建标记
  let marker = null
  
  // 如果有选中的位置，添加标记
  if (selectedLocation.value && selectedLocation.value.latitude && selectedLocation.value.longitude) {
    marker = L.marker([selectedLocation.value.latitude, selectedLocation.value.longitude])
      .addTo(map)
  }
  
  // 地图点击事件（带限流）
  map.on('click', async (e) => {
    const { lat, lng } = e.latlng
    
    const now = Date.now()
    const timeSinceLastClick = now - lastMapClickTime.value
    
    // 检查是否在1秒限流间隔内
    if (lastMapClickTime.value > 0 && timeSinceLastClick < MAP_CLICK_THROTTLE_INTERVAL) {
      // 如果是首次被限流，记录首次被限流的时间
      if (firstThrottledClickTime.value === 0) {
        firstThrottledClickTime.value = now
      }
    }
    
    // 检查是否在5秒冷却时间内
    if (firstThrottledClickTime.value > 0) {
      const timeSinceFirstThrottled = now - firstThrottledClickTime.value
      const elapsedSeconds = Math.floor(timeSinceFirstThrottled / 1000)
      const remainingSeconds = MAP_CLICK_COOLDOWN_SECONDS - elapsedSeconds
      
      if (remainingSeconds > 0) {
        // 在冷却时间内，不进行选点和搜索，只显示提示
        ElMessage.warning(`操作频繁，请等待 ${remainingSeconds} 秒后再重试`)
        return
      } else {
        // 冷却时间已过，重置首次被限流时间
        firstThrottledClickTime.value = 0
      }
    }
    
    // 更新最后点击时间
    lastMapClickTime.value = now
    
    try {
      // 逆地理编码获取地址
      const addressData = await reverseGeocode(lng, lat)
      
      const location = {
        latitude: lat,
        longitude: lng,
        address: addressData.address || ''
      }
      
      // 更新选中位置
      selectedLocation.value = location
      
      // 更新标记
      if (marker) {
        marker.setLatLng([lat, lng])
      } else {
        marker = L.marker([lat, lng]).addTo(map)
      }
      
      // 地图移动到点击位置
      map.setView([lat, lng], map.getZoom())
      
      // 将地址信息回显到搜索框并执行搜索
      if (location.address) {
        // 更新搜索框内容
        locationSearchKeyword.value = location.address
        
        // 清除之前的防抖定时器
        if (searchDebounceTimer) {
          clearTimeout(searchDebounceTimer)
        }
        
        // 延迟执行搜索（防抖）
        searchDebounceTimer = setTimeout(() => {
          handleLocationSearch()
        }, SEARCH_DEBOUNCE_DELAY)
        
        ElMessage.success('位置已选择，正在搜索附近地点...')
      } else {
        ElMessage.info('位置已选择，但未获取到详细地址，可手动输入或使用搜索功能')
      }
    } catch (error) {
      console.error('获取地址失败:', error)
      // 即使获取地址失败，也允许选择位置
      const location = {
        latitude: lat,
        longitude: lng,
        address: ''
      }
      selectedLocation.value = location
      
      if (marker) {
        marker.setLatLng([lat, lng])
      } else {
        marker = L.marker([lat, lng]).addTo(map)
      }
      
      map.setView([lat, lng], map.getZoom())
      
      // 根据错误类型显示不同的提示
      let errorMsg = '位置已选择，但获取地址失败'
      if (error.message) {
        if (error.message.includes('API Key')) {
          errorMsg = '位置已选择，但API密钥配置有误，请检查天地图API Key配置'
        } else if (error.message.includes('网络') || error.message.includes('请求失败')) {
          errorMsg = '位置已选择，但网络请求失败，请检查网络连接或稍后重试'
        } else {
          errorMsg = `位置已选择，但获取地址失败：${error.message}`
        }
      }
      ElMessage.warning(errorMsg)
    }
  })
  
  locationMap = map
  locationMarker = marker
}

// 更新地图位置
const updateMapLocation = (location) => {
  if (!location || !location.latitude || !location.longitude) return
  if (!locationMap) return
  
  selectedLocation.value = location
  
  // 更新地图中心点
  locationMap.setView([location.latitude, location.longitude], 15)
  
  // 更新或创建标记
  if (locationMarker) {
    locationMarker.setLatLng([location.latitude, location.longitude])
  } else {
    locationMarker = L.marker([location.latitude, location.longitude]).addTo(locationMap)
  }
}

// 搜索地点
const handleLocationSearch = async () => {
  if (!locationSearchKeyword.value.trim()) {
    ElMessage.warning('请输入搜索关键词')
    return
  }

  locationSearchLoading.value = true
  try {
    const results = await searchLocation(locationSearchKeyword.value.trim(), {
      count: 10
    })
    locationSearchResults.value = results
    if (results.length === 0) {
      ElMessage.info('未找到相关地点')
    }
  } catch (error) {
    console.error('搜索地点失败:', error)
    ElMessage.error(error.message || '搜索失败')
  } finally {
    locationSearchLoading.value = false
  }
}

// 选择搜索结果
const selectLocationResult = (item) => {
  selectedLocation.value = {
    latitude: item.latitude,
    longitude: item.longitude,
    address: item.fullAddress
  }
  // 将选中的地址回显到搜索框
  locationSearchKeyword.value = item.fullAddress
  // 更新地图位置（不自动执行搜索）
  updateMapLocation(selectedLocation.value)
}

// 确认选择的位置
const confirmLocation = () => {
  if (!selectedLocation.value) {
    ElMessage.warning('请先选择位置')
    return
  }

  customerForm.address = selectedLocation.value.address || ''
  
  locationDialogVisible.value = false
  ElMessage.success('位置已设置')
}

// 定位对话框关闭时清理资源
const handleLocationDialogClose = () => {
  if (locationMap) {
    locationMap.remove()
    locationMap = null
    locationMarker = null
  }
  locationSearchKeyword.value = ''
  locationSearchResults.value = []
  selectedLocation.value = null
  lastMapClickTime.value = 0
  firstThrottledClickTime.value = 0
  // 清除搜索防抖定时器
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
}

// 清理地图资源
onBeforeUnmount(() => {
  if (locationMap) {
    locationMap.remove()
    locationMap = null
    locationMarker = null
  }
  // 清除搜索防抖定时器
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
})
</script>

<style scoped>
.customer-management {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.search-form :deep(.el-form-item) {
  margin-bottom: 18px;
}

/* 是否重点跟进不换行 */
.follow-up-item :deep(.el-form-item__content) {
  display: flex;
  align-items: center;
}

.follow-up-item :deep(.el-switch) {
  margin-left: 0;
}

/* 所在地区样式优化 */
.region-item :deep(.el-form-item__content) {
  display: flex;
  align-items: center;
}

.action-buttons-inline {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.region-select-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.region-separator {
  color: #909399;
  font-size: 14px;
  font-weight: 500;
  padding: 0 4px;
  flex-shrink: 0;
}

/* 列表操作区：三枚按钮换行对齐 */
.customer-table-ops {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.customer-log-dialog :deep(.el-dialog__body) {
  padding-top: 10px;
}

.customer-log-list-wrap {
  min-height: 180px;
  max-height: 520px;
  overflow-y: auto;
}

.customer-log-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.customer-log-card {
  border: 1px solid #ebeef5;
  border-radius: 10px;
  background: #f7f9fc;
  padding: 14px 16px;
}

.customer-log-line {
  line-height: 1.75;
  word-break: break-word;
}

.customer-log-line.is-main {
  color: #303133;
  font-size: 15px;
  font-weight: 500;
}

.customer-log-line.is-sub {
  margin-top: 4px;
  color: #8a94a6;
  font-size: 14px;
}

.customer-log-empty {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

/* 表格容器，确保自适应 */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

/* 表格自适应优化 */
.table-wrapper :deep(.el-table) {
  width: 100%;
  min-width: 100%;
}

/* 小屏幕下优化表格显示 */
@media (max-width: 1400px) {
  .table-wrapper :deep(.el-table) {
    font-size: 13px;
  }
  
  .table-wrapper :deep(.el-table .el-button) {
    padding: 5px 10px;
    font-size: 12px;
  }
}

@media (max-width: 1200px) {
  .table-wrapper :deep(.el-table) {
    font-size: 12px;
  }
  
  .table-wrapper :deep(.el-table .el-button) {
    padding: 4px 8px;
    font-size: 11px;
  }
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 客户详情/编辑对话框样式 */
.customer-detail {
  padding: 0;
}

.detail-card {
  margin-bottom: 20px;
}

.detail-card:last-child {
  margin-bottom: 0;
}

.form-card {
  margin-bottom: 20px;
}

.form-card:last-child {
  margin-bottom: 0;
}

/* 客户新增/编辑弹窗：企业 CRM 区布局与「阶段变更记录跟进」标签不换行 */
.customer-form-dialog :deep(.el-dialog__body) {
  padding-top: 8px;
}

.customer-edit-form .form-card-crm .crm-form-row + .crm-form-row {
  margin-top: 4px;
}

.crm-stage-follow-item :deep(.el-form-item__label) {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 1.3;
  white-space: nowrap;
}

.crm-stage-follow-label {
  white-space: nowrap;
}

.crm-follow-radio-group {
  flex-wrap: nowrap;
}

.crm-stage-follow-wrap {
  width: 100%;
}

.crm-stage-follow-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.title-text {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.title-tip {
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

:deep(.el-descriptions__label) {
  font-weight: 500;
  width: 120px;
}

:deep(.el-descriptions__content) {
  word-break: break-word;
}

.region-select-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.region-separator {
  color: #909399;
  font-size: 14px;
  font-weight: 500;
  padding: 0 4px;
  flex-shrink: 0;
}

.region-select-wrapper {
  display: flex;
  align-items: center;
}

.region-select-wrapper :deep(.el-input) {
  flex: 1;
}

.region-select-wrapper :deep(.el-input__inner) {
  cursor: pointer;
}

.cursor-pointer {
  cursor: pointer;
}

.region-dialog-content {
  padding: 20px 0;
}

/* 定位相关样式 */
.location-picker {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.location-search {
  width: 100%;
}

.location-results {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px;
}

.location-result-item {
  padding: 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.location-result-item:hover {
  background-color: #f5f7fa;
}

.result-name {
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
}

.result-address {
  font-size: 12px;
  color: #909399;
}

.location-map-container {
  position: relative;
  width: 100%;
  height: 400px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.location-map {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  z-index: 0;
}

/* 隐藏地图占位符，地图会直接显示 */
.map-placeholder {
  display: none;
}

.map-tip {
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-size: 12px;
  color: #909399;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 1000;
}

.selected-location-info {
  margin-top: 8px;
}
</style>

